module.exports = __webpack_public_path__ + "static/media/yt.7a0245ef.svg";